import {
  FormGroupLabel,
  FormRadioGroup,
  useDialogContext,
  useStoreState,
} from "@ariakit/react";
import { Army } from "../../domain/army";
import { atomic } from "../atomic.css";
import { RadioField } from "../checkbox-field";
import { useDatabase } from "../database-provider";
import { FormDialog } from "../form-dialog";
import { useForm } from "../hooks/use-form";
import { useRuleset } from "../ruleset-provider/context";

export function ArmyKeywordsDialog(props: { army: Army }) {
  const { army } = props;
  const db = useDatabase();
  const store = useDialogContext();
  const ruleset = useRuleset();

  const form = useForm({
    defaultValues: {
      keywordId: army.keyword?.id ?? null,
    },
    async onSubmit(values) {
      await db.updateArmy({
        ...army.data,
        ruleset_version: ruleset.version,
        keywords: values.keywordId ? [{ id: values.keywordId, count: 1 }] : [],
      });
      store?.hide();
    },
  });

  const { keywordId } = useStoreState(form, (s) => s.values);
  const keywordDefs = Array.from(props.army.ruleset.keywordDefs.values());

  return (
    <FormDialog form={form} heading="Army Keywords" submitLabel="Save">
      <FormRadioGroup>
        <FormGroupLabel
          className={atomic({
            borderBlockEnd: "solid",
            paddingBlockEnd: 6,
            fontWeight: "medium",
          })}
        >
          Keywords
        </FormGroupLabel>

        {keywordDefs.map((def) => {
          // Do not offer to add keywords that are not purchaseable for an army
          if (def.army_cost === undefined) {
            return null;
          }

          return (
            <div
              key={def.id}
              className={atomic({
                borderBlockEnd: "dashed",
              })}
            >
              <div
                className={atomic({
                  display: "grid",
                  gridTemplateColumns: "fraction-auto",
                  paddingBlock: 16,
                  fontFamily: "arboria",
                  fontWeight: "black",
                  fontStyle: "italic",
                })}
              >
                <RadioField
                  label={def.name}
                  name={form.names.keywordId}
                  value={def.id}
                  className={atomic({ marginInlineEnd: 12 })}
                  onClick={() => {
                    if (keywordId === def.id) {
                      form.setValue(form.names.keywordId, null);
                    }
                  }}
                />
                <span>
                  {def.army_cost === 0 ? "Free" : `${def.army_cost}pts`}
                </span>
              </div>

              <div
                className={atomic({
                  fontSize: 14,
                  paddingBlockEnd: 16,
                  lineHeight: 1.5,
                })}
              >
                {def.description}
              </div>
            </div>
          );
        })}
      </FormRadioGroup>
    </FormDialog>
  );
}
